import {Fill, Stroke, Style} from "ol/style";
import Circle from "ol/style/Circle";

export const boundariesStyle = () => {
    return new Style({
        image: new Circle({
            fill: new Fill({
                color: '#9d0354'
            }),
            stroke: new Stroke({
                color: 'rgba(38,171,5,0.8)'
            }),
            radius: 5
        }),
        stroke: new Stroke({
            color: '#9d0354',
            width: 2
        }),
        fill: new Fill({
            color: 'transparent'
        })
    })
}
